
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13050',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13050",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.490",
  "data-fetching-client": "static-1.9876",
  "foundations-components": "static-1.8340",
  "foundations-components-legacy": "static-1.1365",
  "foundations-theming": "static-1.4669",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.85",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8242",
  "hub-http-shared-msw-handlers": "static-1.10480",
  "hubspot-dlb": "static-2.1877",
  "hubspot-url-utils": "static-1.4282",
  "HubStyleTokens": "static-2.11698",
  "I18n": "static-7.1652",
  "jasmine-runner": "static-1.6667",
  "marketplace-discovery-studio-lib": "static-1.502",
  "marketplace-storefront-base": "static-1.13113",
  "quartz": "static-1.7324",
  "react-dlb": "static-1.84",
  "react-rhumb": "static-1.16925",
  "reactive-variable-buffer-atom": "static-1.3071",
  "reporting-testing-lib": "static-1.10410",
  "reselect": "static-3.8",
  "settings-ui-lib": "static-1.12738",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7519",
  "ui-addon-i18n": "static-1.11364",
  "ui-addon-react-router-dom": "static-1.9751",
  "unified-auth": "static-1.756",
  "unified-auth-core-lib": "static-1.1038",
  "usage-tracker": "static-1.7574",
  "usage-tracker-core": "static-1.7424",
  "customer-data-property-utils": "static-1.8314",
  "hub-http": "static-1.6432",
  "integrations-lib": "static-1.16864",
  "marketplace-ui-common": "static-1.20497",
  "marketplace-ui-install": "static-1.483",
  "property-management-iframe": "static-1.13900",
  "quartz-config": "static-1.1102",
  "quartz-core": "static-1.6543",
  "quartz-routing": "static-1.754",
  "quick-fetch": "static-1.4068",
  "react": "static-7.190",
  "rpc-client-utils": "static-1.4880",
  "ts-schema": "static-1.4229",
  "ui-universal-auth": "static-1.9242",
  "UIComponents": "static-3.8644",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9849",
  "react-redux": "static-7.75",
  "redux": "static-4.16",
  "styled-components": "static-2.94",
  "bend-plugin-trellis-migration": "static-1.3551",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3601",
  "quartz-webpack": "static-1.3548",
  "bend-plugin-quartz-routing": "static-1.402",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4609",
  "floating-ui": "static-1.60",
  "foundations-assets": "static-1.5092",
  "foundations-theming-specialty": "static-1.2385",
  "framer-motion": "static-1.75",
  "hs-story-utils": "static-1.9643",
  "react-aria": "static-1.69",
  "react-create-root-preference": "static-1.52",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5492",
  "react-virtualized": "static-2.103",
  "StyleGuideUI": "static-3.492",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2388",
  "ui-fonts": "static-1.960",
  "ui-images": "static-2.1219",
  "bend-plugin-foundations-theming": "static-1.3152",
  "foundations-theming-base": "static-1.3654",
  "stylex": "static-1.37",
  "HeadJS": "static-2.782",
  "hs-test-utils-bend-plugin": "static-1.3353",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.226",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4537",
  "ui-addon-video-player": "static-1.8922",
  "ai-components-ui-library": "static-1.9526",
  "ai-rendering-library": "static-1.10946",
  "chirp-fetch": "static-1.2106",
  "connections-embed-lib": "static-1.1388",
  "copilot-toolkit": "static-1.11692",
  "feedback-loader": "static-1.29694",
  "laboratory-lib": "static-3.7369",
  "marketplace-embed": "static-1.22756",
  "marketplace-ui-details": "static-1.10392",
  "marketplace-ui-reviews": "static-1.20452",
  "marketplace-ui-tracking": "static-1.14667",
  "sanitize-text": "static-1.8367",
  "usage-tracker-multi": "static-1.5988",
  "usage-tracker-session-replay": "static-1.5260",
  "wootric-nps": "static-1.7137",
  "quartz-head": "static-1.989",
  "web-vitals": "static-1.9",
  "apollo-link-hub-http": "static-2.4875",
  "immer": "static-1.94",
  "immerable": "static-1.4368",
  "highcharts": "static-8.107",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2635",
  "reporting-data": "static-1.68477",
  "cssUtils": "static-1.857",
  "flux-actions": "static-1.356",
  "HubStyle": "static-2.12005",
  "PatternValidationJS": "static-1.3115",
  "react-colorpicker": "static-2.10428",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10583",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7564",
  "icons": "static-2.671",
  "marketplace-ui-apps-core": "static-1.19029",
  "storybook-react": "static-1.36",
  "trellis-story-utils": "static-1.4727",
  "foundations-components-test-utils": "static-1.5823",
  "quartz-i18n": "static-1.999",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.299",
  "ads-unified-auth-lib": "static-1.867",
  "google-sheets-integration-lib": "static-1.878",
  "microsoft-drive-integration-lib": "static-1.1007",
  "surveymonkey-integration-lib": "static-1.321",
  "slack-ui-library": "static-1.10616",
  "fsm": "static-1.3953",
  "customer-data-objects": "static-1.7902",
  "property-translator": "static-1.5613",
  "hs-locale-management": "static-1.231",
  "frontend-preferences-client": "static-1.8146",
  "hs-promise-utils": "static-1.5811",
  "hubspot-apollo-client": "static-1.5095",
  "integrations-error-boundary-lib": "static-1.14279",
  "integrations-tracking-lib": "static-1.5826",
  "native-integrations-shared-strings": "static-1.7995",
  "sanitize": "static-1.4694",
  "superstore": "static-1.4974",
  "ui-shepherd-react": "static-3.10479",
  "ai-settings-ui-library": "static-1.8218",
  "hub-http-janus": "static-1.860",
  "hubspotter-http": "static-1.4801",
  "immutable-less": "static-1.4868",
  "marketplace-ui-client-types": "static-1.17904",
  "nav-meta": "static-1.30306",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18287",
  "ui-product-approvals-common": "static-1.837",
  "ai-studio-lib": "static-1.12283",
  "hubspot-prosemirror": "static-1.18852",
  "integrations-reconnect-lib": "static-1.361",
  "ui-addon-iframeable": "static-1.9294",
  "ui-addon-integrations-directory-panel": "static-2.8242",
  "ui-product-approvals": "static-1.28942",
  "ui-tool-access": "static-1.10371",
  "inbound-db-properties-service-client": "static-1.3997",
  "property-management-common": "static-1.6188",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.557",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.999",
  "quartz-test": "static-1.999",
  "quartz-tracking": "static-1.703",
  "trellis-components": "static-1.2407",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.290",
  "bender-build-tools": "static-1.3344",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22479",
  "ContentUtils": "static-1.69000",
  "customer-data-objects-ui-components": "static-1.13247",
  "sassPrefix": "static-1.161",
  "avatar-components": "static-1.2715",
  "breeze-engine-core": "static-1.785",
  "breeze-onboarding-components": "static-1.564",
  "customer-data-filters-ui": "static-1.40657",
  "customer-data-reference-ui-components": "static-1.13395",
  "embedded-academy-lib": "static-1.15254",
  "ExportDialog": "static-6.10598",
  "highlight.js": "static-1.82",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41858",
  "reporting-snowflake": "static-1.57095",
  "reporting-ui-components": "static-2.65748",
  "reporting-visualizations": "static-1.60553",
  "trellis-theming": "static-1.1171",
  "ui-addon-teams": "static-1.21824",
  "upgrade-components-lib": "static-1.423",
  "magpie-lib": "static-1.5703",
  "navigation-components": "static-1.18669",
  "breeze-engine-lib": "static-1.1507",
  "magpie-types": "static-1.5163",
  "simple-logging-lib": "static-1.3266",
  "fail-safe": "static-1.167",
  "app-governance-lib": "static-1.2235",
  "developer-experience-shared-components": "static-1.10716",
  "purchase-motions-components": "static-1.6250",
  "transmute": "static-2.85",
  "usage-based-billing-components-lib": "static-1.9912",
  "usage-tracker-anonymous": "static-1.5991",
  "usage-tracker-public": "static-1.7385",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.3919",
  "reference-resolvers": "static-1.8400",
  "ui-extensibility-client-types": "static-1.4138",
  "hubspot-apollo-cache": "static-1.554",
  "universal-page-editor-lib": "static-1.3229",
  "final-form": "static-1.73",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3391",
  "atom": "static-1.5293",
  "merchandise-lib": "static-1.272",
  "salesImages": "static-1.530",
  "codemirror": "static-5.98",
  "react-codemirror": "static-1.10857",
  "ui-addon-draggable": "static-3.4972",
  "content-assistance-lib": "static-1.8095",
  "content-media-capture": "static-1.5223",
  "customer-data-ui-utilities": "static-1.10044",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24296",
  "growth-payments-core": "static-1.26018",
  "knowledge-content-types": "static-1.8610",
  "payment-link-components": "static-1.24028",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20195",
  "ui-addon-emoji-picker": "static-1.10104",
  "ui-business-units-lib": "static-1.9299",
  "video-components-external": "static-1.11989",
  "video-data-lib": "static-1.35647",
  "navigation-messaging": "static-1.7996",
  "collaboration-sidebar": "static-1.58549",
  "react-dnd-compat": "static-1.4834",
  "batch-promise": "static-1.1762",
  "crm-component-utils": "static-1.39681",
  "crm-properties-common-lib": "static-1.6106",
  "customer-data-properties": "static-1.52354",
  "external-options-client-types": "static-1.4277",
  "framework-data-schema-resolvers": "static-1.7111",
  "property-value-citations": "static-1.2968",
  "reference-resolvers-lite": "static-1.8315",
  "hubspotter-http-shared-msw-handlers": "static-1.10478",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "tanstack-virtual": "static-1.35",
  "cms-field-types": "static-1.5032",
  "content-icons-ui": "static-1.2292",
  "breeze-artifacts-sdk": "static-1.97",
  "onboarding-journeys-lib": "static-1.720",
  "pulse": "static-1.838",
  "conversations-skeleton-state": "static-1.7467",
  "crm-message-bus": "static-1.43576",
  "customer-data-filters-ui-msw-helpers": "static-1.23092",
  "events-data-lib": "static-1.459",
  "FormUrlGenerator": "static-2.4942",
  "framework-builder-read-service-client": "static-1.4158",
  "framework-data-schema-quick-fetch": "static-1.7016",
  "multi-account-reference-resolvers": "static-1.1201",
  "onboarding-tours": "static-1.17000",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14317",
  "academy-common-lib": "static-1.14714",
  "dashboard-lib": "static-1.82458",
  "getting-started-shared-tasks": "static-1.19057",
  "hubspot-prosemirror-plugins": "static-1.18844",
  "share-with-third-party-component-lib": "static-1.8922",
  "ui-asset-management-lib": "static-1.11308",
  "user-context": "static-1.5331",
  "reporting-plugins": "static-1.10668",
  "reporting-reports": "static-1.68155",
  "idb-keyval": "static-1.47",
  "reactive-lib": "static-1.938",
  "nest": "static-1.455",
  "breeze-engine-chat-components": "static-1.485",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.118",
  "framework-listing-lib": "static-2.29317",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31237",
  "apps-service-types": "static-1.3984",
  "oauth-service-types": "static-1.4472",
  "onboarding-scopes": "static-1.6675",
  "purchase-motions-api": "static-1.6253",
  "signup-constants": "static-1.19443",
  "signup-ui-url-generator": "static-2.8275",
  "onboarding-tours-client": "static-1.5214",
  "one-click-checkout": "static-1.298",
  "platform-infra-nav-components": "static-1.7821",
  "subscription-experience-data-types": "static-1.15162",
  "crm-record-cards-service-types": "static-1.3735",
  "location-customization-utils-lib": "static-1.9935",
  "redux-thunk": "static-2.43",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "react-flip-move": "static-1.74",
  "ui-coaching-tips": "static-1.29163",
  "content-media-composition-data-lib": "static-1.13027",
  "fix-webm-duration": "static-1.26",
  "notification-sounds": "static-1.4643",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.531",
  "ui-addon-opt": "static-4.8579",
  "commerce-tours-lib": "static-1.6496",
  "growth-onboarding-reliability": "static-1.5298",
  "sales-checkout-service-client": "static-1.3754",
  "data-token-picker": "static-1.16778",
  "FileManagerLib": "static-1.39936",
  "content-media-compositions": "static-2.17034",
  "media-bridge-lib": "static-1.19297",
  "chatspot-widget-iframe": "static-1.22470",
  "collaboration-sidebar-common": "static-1.3346",
  "marketing-platform-lib": "static-1.7087",
  "card-properties-lib": "static-1.44849",
  "commerce-subscription-lib": "static-1.37624",
  "crm-actions": "static-1.6568",
  "crm-cards-sdk": "static-1.44310",
  "customer-data-properties-shared-msw-handlers": "static-1.9807",
  "customer-data-tracking": "static-1.7101",
  "hs-resources": "static-1.403",
  "calling-global-api": "static-1.65273",
  "calling-internal-common": "static-1.31532",
  "calling-lifecycle-internal": "static-1.66655",
  "calling-lifecycle-messages": "static-1.58949",
  "commerce-products-lib": "static-1.10346",
  "conditional-properties-service-client": "static-1.3948",
  "crm-links": "static-1.6536",
  "crm-index-visualization-core": "static-1.4430",
  "crm-pipelines-api-client-types": "static-1.4285",
  "formula-editor": "static-1.14636",
  "google-libphonenumber": "static-1.41",
  "inbounddb-objects-service-types": "static-1.4365",
  "meetings-icalendar-utils-lib": "static-1.852",
  "multi-currency-client-types": "static-1.3842",
  "object-builder-ui-client": "static-1.49459",
  "pipeline-validation-client-types": "static-1.4118",
  "smart-property-lib": "static-1.8125",
  "tiered-pricing": "static-1.1815",
  "topics-actions-lib": "static-1.376",
  "ui-addon-form-validation": "static-1.11204",
  "zustand": "static-1.79",
  "fdsr-migration-layer": "static-1.230",
  "bend-plugin-pulse": "static-1.341",
  "event-emitter": "static-1.1170",
  "fast-json-patch": "static-1.66",
  "restore-request-side-panel-lib": "static-1.1471",
  "growth-data-modal": "static-1.5779",
  "growth-onboarding-confetti": "static-1.3277",
  "growth-onboarding-next-action-utils": "static-1.2542",
  "onboarding-tours-utils": "static-1.1066",
  "ui-shepherd-tracker": "static-1.7860",
  "academy-service-client": "static-1.3906",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39795",
  "SafeStorage": "static-1.4621",
  "video-embed": "static-1.36481",
  "redux-actions": "static-3.7",
  "EmailSignatureEditor": "static-1.24868",
  "viral-links-lib": "static-1.7291",
  "nested-table": "static-1.453",
  "timezone-utils": "static-2.5465",
  "getting-started-shared-tasks-store": "static-1.18175",
  "campaign-roi-lib": "static-1.9929",
  "ui-addon-calendars": "static-2.5542",
  "customer-data-views-management": "static-1.25890",
  "framework-data-table": "static-2.12398",
  "nudge-client-utils": "static-1.3028",
  "nudge-custom-ui-functions": "static-1.1382",
  "switchboard-lib": "static-1.439",
  "access-check-ui-lib": "static-1.1424",
  "app-users-service-client": "static-1.5834",
  "app-users-service-types": "static-1.5242",
  "mini-checkout-client": "static-1.27393",
  "onboarding-utils": "static-1.5580",
  "permissions-shared-i18n-strings-fe": "static-1.2104",
  "ui-coaching-tips-shared-config": "static-1.29148",
  "checkout-sdk": "static-3.24236",
  "payment-method-components": "static-1.7065",
  "touchless-buying-components": "static-1.6104",
  "upgrade-catalog-service-types": "static-1.3706",
  "edison-service-client-types": "static-1.605",
  "growth-onboarding-feedback-components": "static-1.6800",
  "audio-components": "static-1.6236",
  "FileManagerImages": "static-1.37447",
  "video-components": "static-1.13991",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92683",
  "customer-data-sidebar": "static-2.46595",
  "enrichment-properties-lib": "static-1.17667",
  "ui-addon-draggable-compat": "static-2.4479",
  "universal-record-utils-lib": "static-1.1641",
  "commerce-billing-lib": "static-1.19872",
  "commerce-shared-components-lib": "static-1.19082",
  "commerce-tools-ui-lib": "static-1.10912",
  "crm-fe-perf": "static-1.23116",
  "calling-error-reporting": "static-1.31539",
  "shared-worker-versioning": "static-1.11257",
  "calling-usage-tracker": "static-1.6757",
  "voice-sms-access-library": "static-1.1798",
  "commerce-permissions": "static-1.995",
  "products-iframe-lib": "static-1.8448",
  "products-ui-components-shared-msw-handlers": "static-1.10862",
  "crm-index-associations-lib": "static-1.6659",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10563",
  "sales-views-client-types": "static-1.4475",
  "bark-lib": "static-1.16723",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.533",
  "policy-lib": "static-1.7011",
  "react-tinymce": "static-1.55822",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10626",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54948",
  "tinymce-plugins": "static-1.58062",
  "tinymce-themes": "static-1.56918",
  "onboarding-data-sync-lib": "static-1.2350",
  "growth-onboarding-next-action-components": "static-1.2570",
  "user-context-client": "static-1.4754",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.57",
  "urlinator": "static-1.4749",
  "outpost": "static-1.4380",
  "draft-convert": "static-2.76",
  "draft-extend": "static-3.79",
  "draft-js": "static-5.81",
  "draft-plugins": "static-2.22045",
  "sales-email-signature-service-client": "static-1.4063",
  "ts-utils-lib": "static-1.391",
  "crm-export-dialog": "static-1.6503",
  "crm-view-components": "static-1.936",
  "react-beautiful-dnd": "static-1.66",
  "customer-data-associations": "static-1.7550",
  "nudge-custom-function-registry": "static-1.2785",
  "nudge-renderer-utils": "static-1.3104",
  "whisper-core-api": "static-1.7170",
  "InboxConnectUtils": "static-4.15405",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46695",
  "hub-http-rxjs": "static-1.825",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4209",
  "company-details-components": "static-1.6418",
  "react-performance-metrics-lib": "static-1.772",
  "pricing-pages-ui-components": "static-1.15303",
  "quote-checkout-service-types": "static-1.3673",
  "social-insights-client-types": "static-1.22638",
  "crm_universal": "static-1.22385",
  "customer-data-email": "static-1.18413",
  "card-payment-highlight-lib": "static-1.37818",
  "card-subscription-highlight-lib": "static-1.40047",
  "commerce-contract-lib": "static-1.13090",
  "invoices-highlight-card-lib": "static-1.55449",
  "orders-highlight-card-lib": "static-1.22038",
  "products-highlight-card-lib": "static-1.18629",
  "quotes-highlight-card-lib": "static-1.72688",
  "crm-source-interpretation-lib": "static-1.5552",
  "crm-object-search-query-utilities": "static-1.10056",
  "utility-belt": "static-1.2749",
  "payments-enrollment-embed-lib": "static-1.23652",
  "stripe-embedded-components": "static-1.7885",
  "customer-data-rte": "static-1.33516",
  "cv-backend-services": "static-1.1590",
  "growth-onboarding-empty-states": "static-1.6154",
  "payments-post-enroll-local-storage-lib": "static-1.5323",
  "qrcode-generator": "static-1.72",
  "quotes-client-types": "static-1.38778",
  "calling-orchestration-schema": "static-1.36575",
  "react-reducer-toolkit": "static-1.16216",
  "hub-http-contrib": "static-1.3257",
  "interframe": "static-3.4973",
  "tinymce-data": "static-1.41033",
  "ui-addon-sales-email": "static-1.5430",
  "layout-dnd-components": "static-1.12852",
  "layout-dnd-utils": "static-1.11827",
  "ui-brand-identity-lib": "static-1.16106",
  "NamespacedHubStyle": "static-2.9200",
  "meetings-connect-utils-lib": "static-1.7825",
  "access-control-lib": "static-1.10656",
  "EmailComponents": "static-1.55400",
  "EmailData": "static-1.54078",
  "redux-less": "static-2.9698",
  "company-details-service-types": "static-1.4157",
  "segments-query-core": "static-1.1639",
  "pricing-pages-api": "static-1.15168",
  "sequences-lib": "static-1.8410",
  "ui-gdpr-components": "static-1.10572",
  "products-ui-components": "static-1.40864",
  "accounting-integrations-ui-components": "static-1.7426",
  "invoices-ui-lib": "static-1.55465",
  "commerce-products-api": "static-1.2604",
  "invoices-iframe-lib": "static-1.57523",
  "quotes-modal-lib": "static-1.103366",
  "quotes-ui-lib": "static-1.81409",
  "stripe-connect-js": "static-1.73",
  "draft-content-plugins": "static-1.28779",
  "ContentData": "static-1.69075",
  "layout-data-lib": "static-1.10152",
  "ContentComponents": "static-2.71956",
  "marketing-contacts-lib": "static-1.10808",
  "marketing-email-service-types": "static-1.2056",
  "messaging-editing-lib": "static-1.46976",
  "messaging-usage-based-billing-components-lib": "static-1.1838",
  "automation-ui-source-apps": "static-1.19509",
  "automation-ui-types": "static-1.20427",
  "messaging-types-lib": "static-1.46713",
  "onboarding-settings-client": "static-1.4727",
  "sequences-client-types-lib": "static-1.8267",
  "commerce-tax-lib": "static-1.759",
  "price-books-api": "static-1.1564",
  "price-books-components": "static-1.1622",
  "property-description-translator": "static-1.4057",
  "ramp-editor": "static-1.749",
  "commerce-analytics-service-client": "static-1.3742",
  "totals-ui-components": "static-1.24158",
  "SalesContentIndexUI": "static-3.9532",
  "advanced-menus-core": "static-1.15477",
  "advanced-menus-lib": "static-1.12362",
  "ui-memberships-settings-lib": "static-1.34659",
  "automation-ui-ubb": "static-1.6343",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7552",
  "data-token-views": "static-1.16759",
  "forms-utils-lib": "static-1.12978",
  "payments-embed-points-lib": "static-1.13467",
  "simple-menus-core": "static-1.15476",
  "simple-menus-lib": "static-1.16993",
  "videoconference-integration-components": "static-1.7140",
  "marketing-contacts-client": "static-1.7724",
  "mc-hard-limits-client-types": "static-1.119",
  "automation-applications-service-types": "static-1.3632",
  "automation-platform-service-types": "static-1.2643",
  "ContentEditorUI": "static-2.77735",
  "short-messages-app-service-client": "static-1.4139",
  "web-interactives-components": "static-1.14135",
  "web-interactives-data": "static-1.14136",
  "messaging-shared-utils-lib": "static-1.1287",
  "messaging-user-info-utils-lib": "static-1.1457",
  "email-portal-health-service-types": "static-1.1196",
  "line-items-api": "static-1.1004",
  "commerce-totals-service-types": "static-1.3967",
  "FireAlarmUi": "static-1.4660",
  "sales-templates-service-types-lib": "static-1.4318",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22363",
  "automation-ui-usage-tracking": "static-1.21826",
  "data-studio-ubb": "static-1.3361",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27522",
  "content-management-data-lib": "static-1.5828",
  "copilot-plugins": "static-1.11664",
  "cta-picker": "static-1.36946",
  "customer-agent-discovery-components-lib": "static-1.3728",
  "editor-components": "static-1.13541",
  "editor-iframe-lib": "static-1.8699",
  "error-messaging-js": "static-1.5413",
  "FormsCommonComponents": "static-1.86428",
  "pictos": "static-7.189",
  "react-transition-group": "static-2.68",
  "redux-request-state": "static-1.10867",
  "SharedLegalStrings": "static-1.1964",
  "smart-content-core": "static-1.43028",
  "smart-content-lib": "static-1.43681",
  "social-composer-lib": "static-1.59991",
  "structured-content-lib": "static-1.25772",
  "theme-previewer-lib": "static-1.53799",
  "tinymce-copilot": "static-1.17016",
  "xray-recommendation-lib": "static-1.8176",
  "automation-ui-routing": "static-1.21784",
  "sql-reporting-client-types": "static-1.5825",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42660",
  "campaigns-utils-lib": "static-1.3414",
  "reporting-enablement": "static-1.23654",
  "forms-ai-lib": "static-1.4651",
  "codemirror-dlb": "static-1.59294",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6655",
  "report-customization-components": "static-1.13746",
  "data-quality-ui-library": "static-1.13617",
  "reporting-filters": "static-1.863",
  "reporting-insights-lib": "static-1.2402"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13050",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.490",
  "data-fetching-client": "/data-fetching-client/static-1.9876",
  "foundations-components": "/foundations-components/static-1.8340",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1365",
  "foundations-theming": "/foundations-theming/static-1.4669",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.85",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8242",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10480",
  "hubspot-dlb": "/hubspot-dlb/static-2.1877",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4282",
  "HubStyleTokens": "/HubStyleTokens/static-2.11698",
  "I18n": "/I18n/static-7.1652",
  "jasmine-runner": "/jasmine-runner/static-1.6667",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.502",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13113",
  "quartz": "/quartz/static-1.7324",
  "react-dlb": "/react-dlb/static-1.84",
  "react-rhumb": "/react-rhumb/static-1.16925",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3071",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10410",
  "reselect": "/reselect/static-3.8",
  "settings-ui-lib": "/settings-ui-lib/static-1.12738",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7519",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11364",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9751",
  "unified-auth": "/unified-auth/static-1.756",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1038",
  "usage-tracker": "/usage-tracker/static-1.7574",
  "usage-tracker-core": "/usage-tracker-core/static-1.7424",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8314",
  "hub-http": "/hub-http/static-1.6432",
  "integrations-lib": "/integrations-lib/static-1.16864",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20497",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.483",
  "property-management-iframe": "/property-management-iframe/static-1.13900",
  "quartz-config": "/quartz-config/static-1.1102",
  "quartz-core": "/quartz-core/static-1.6543",
  "quartz-routing": "/quartz-routing/static-1.754",
  "quick-fetch": "/quick-fetch/static-1.4068",
  "react": "/react/static-7.190",
  "rpc-client-utils": "/rpc-client-utils/static-1.4880",
  "ts-schema": "/ts-schema/static-1.4229",
  "ui-universal-auth": "/ui-universal-auth/static-1.9242",
  "UIComponents": "/UIComponents/static-3.8644",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9849",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.94",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3551",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3601",
  "quartz-webpack": "/quartz-webpack/static-1.3548",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.402",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4609",
  "floating-ui": "/floating-ui/static-1.60",
  "foundations-assets": "/foundations-assets/static-1.5092",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2385",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-story-utils": "/hs-story-utils/static-1.9643",
  "react-aria": "/react-aria/static-1.69",
  "react-create-root-preference": "/react-create-root-preference/static-1.52",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5492",
  "react-virtualized": "/react-virtualized/static-2.103",
  "StyleGuideUI": "/StyleGuideUI/static-3.492",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2388",
  "ui-fonts": "/ui-fonts/static-1.960",
  "ui-images": "/ui-images/static-2.1219",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3152",
  "foundations-theming-base": "/foundations-theming-base/static-1.3654",
  "stylex": "/stylex/static-1.37",
  "HeadJS": "/HeadJS/static-2.782",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3353",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.226",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4537",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8922",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9526",
  "ai-rendering-library": "/ai-rendering-library/static-1.10946",
  "chirp-fetch": "/chirp-fetch/static-1.2106",
  "connections-embed-lib": "/connections-embed-lib/static-1.1388",
  "copilot-toolkit": "/copilot-toolkit/static-1.11692",
  "feedback-loader": "/feedback-loader/static-1.29694",
  "laboratory-lib": "/laboratory-lib/static-3.7369",
  "marketplace-embed": "/marketplace-embed/static-1.22756",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10392",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20452",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14667",
  "sanitize-text": "/sanitize-text/static-1.8367",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5988",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5260",
  "wootric-nps": "/wootric-nps/static-1.7137",
  "quartz-head": "/quartz-head/static-1.989",
  "web-vitals": "/web-vitals/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4875",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4368",
  "highcharts": "/highcharts/static-8.107",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2635",
  "reporting-data": "/reporting-data/static-1.68477",
  "cssUtils": "/cssUtils/static-1.857",
  "flux-actions": "/flux-actions/static-1.356",
  "HubStyle": "/HubStyle/static-2.12005",
  "PatternValidationJS": "/PatternValidationJS/static-1.3115",
  "react-colorpicker": "/react-colorpicker/static-2.10428",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10583",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7564",
  "icons": "/icons/static-2.671",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19029",
  "storybook-react": "/storybook-react/static-1.36",
  "trellis-story-utils": "/trellis-story-utils/static-1.4727",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5823",
  "quartz-i18n": "/quartz-i18n/static-1.999",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.299",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.867",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.878",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.1007",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.321",
  "slack-ui-library": "/slack-ui-library/static-1.10616",
  "fsm": "/fsm/static-1.3953",
  "customer-data-objects": "/customer-data-objects/static-1.7902",
  "property-translator": "/property-translator/static-1.5613",
  "hs-locale-management": "/hs-locale-management/static-1.231",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8146",
  "hs-promise-utils": "/hs-promise-utils/static-1.5811",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5095",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14279",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5826",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7995",
  "sanitize": "/sanitize/static-1.4694",
  "superstore": "/superstore/static-1.4974",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10479",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8218",
  "hub-http-janus": "/hub-http-janus/static-1.860",
  "hubspotter-http": "/hubspotter-http/static-1.4801",
  "immutable-less": "/immutable-less/static-1.4868",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17904",
  "nav-meta": "/nav-meta/static-1.30306",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18287",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.837",
  "ai-studio-lib": "/ai-studio-lib/static-1.12283",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18852",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.361",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9294",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8242",
  "ui-product-approvals": "/ui-product-approvals/static-1.28942",
  "ui-tool-access": "/ui-tool-access/static-1.10371",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3997",
  "property-management-common": "/property-management-common/static-1.6188",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.557",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.999",
  "quartz-test": "/quartz-test/static-1.999",
  "quartz-tracking": "/quartz-tracking/static-1.703",
  "trellis-components": "/trellis-components/static-1.2407",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.290",
  "bender-build-tools": "/bender-build-tools/static-1.3344",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22479",
  "ContentUtils": "/ContentUtils/static-1.69000",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13247",
  "sassPrefix": "/sassPrefix/static-1.161",
  "avatar-components": "/avatar-components/static-1.2715",
  "breeze-engine-core": "/breeze-engine-core/static-1.785",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.564",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40657",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13395",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15254",
  "ExportDialog": "/ExportDialog/static-6.10598",
  "highlight.js": "/highlight.js/static-1.82",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41858",
  "reporting-snowflake": "/reporting-snowflake/static-1.57095",
  "reporting-ui-components": "/reporting-ui-components/static-2.65748",
  "reporting-visualizations": "/reporting-visualizations/static-1.60553",
  "trellis-theming": "/trellis-theming/static-1.1171",
  "ui-addon-teams": "/ui-addon-teams/static-1.21824",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.423",
  "magpie-lib": "/magpie-lib/static-1.5703",
  "navigation-components": "/navigation-components/static-1.18669",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1507",
  "magpie-types": "/magpie-types/static-1.5163",
  "simple-logging-lib": "/simple-logging-lib/static-1.3266",
  "fail-safe": "/fail-safe/static-1.167",
  "app-governance-lib": "/app-governance-lib/static-1.2235",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10716",
  "purchase-motions-components": "/purchase-motions-components/static-1.6250",
  "transmute": "/transmute/static-2.85",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9912",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5991",
  "usage-tracker-public": "/usage-tracker-public/static-1.7385",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.3919",
  "reference-resolvers": "/reference-resolvers/static-1.8400",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4138",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.554",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3229",
  "final-form": "/final-form/static-1.73",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3391",
  "atom": "/atom/static-1.5293",
  "merchandise-lib": "/merchandise-lib/static-1.272",
  "salesImages": "/salesImages/static-1.530",
  "codemirror": "/codemirror/static-5.98",
  "react-codemirror": "/react-codemirror/static-1.10857",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4972",
  "content-assistance-lib": "/content-assistance-lib/static-1.8095",
  "content-media-capture": "/content-media-capture/static-1.5223",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10044",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24296",
  "growth-payments-core": "/growth-payments-core/static-1.26018",
  "knowledge-content-types": "/knowledge-content-types/static-1.8610",
  "payment-link-components": "/payment-link-components/static-1.24028",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20195",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10104",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9299",
  "video-components-external": "/video-components-external/static-1.11989",
  "video-data-lib": "/video-data-lib/static-1.35647",
  "navigation-messaging": "/navigation-messaging/static-1.7996",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58549",
  "react-dnd-compat": "/react-dnd-compat/static-1.4834",
  "batch-promise": "/batch-promise/static-1.1762",
  "crm-component-utils": "/crm-component-utils/static-1.39681",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6106",
  "customer-data-properties": "/customer-data-properties/static-1.52354",
  "external-options-client-types": "/external-options-client-types/static-1.4277",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7111",
  "property-value-citations": "/property-value-citations/static-1.2968",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8315",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10478",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "tanstack-virtual": "/tanstack-virtual/static-1.35",
  "cms-field-types": "/cms-field-types/static-1.5032",
  "content-icons-ui": "/content-icons-ui/static-1.2292",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.97",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.720",
  "pulse": "/pulse/static-1.838",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7467",
  "crm-message-bus": "/crm-message-bus/static-1.43576",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23092",
  "events-data-lib": "/events-data-lib/static-1.459",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4942",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4158",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7016",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1201",
  "onboarding-tours": "/onboarding-tours/static-1.17000",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14317",
  "academy-common-lib": "/academy-common-lib/static-1.14714",
  "dashboard-lib": "/dashboard-lib/static-1.82458",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19057",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18844",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8922",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11308",
  "user-context": "/user-context/static-1.5331",
  "reporting-plugins": "/reporting-plugins/static-1.10668",
  "reporting-reports": "/reporting-reports/static-1.68155",
  "idb-keyval": "/idb-keyval/static-1.47",
  "reactive-lib": "/reactive-lib/static-1.938",
  "nest": "/nest/static-1.455",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.485",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.118",
  "framework-listing-lib": "/framework-listing-lib/static-2.29317",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31237",
  "apps-service-types": "/apps-service-types/static-1.3984",
  "oauth-service-types": "/oauth-service-types/static-1.4472",
  "onboarding-scopes": "/onboarding-scopes/static-1.6675",
  "purchase-motions-api": "/purchase-motions-api/static-1.6253",
  "signup-constants": "/signup-constants/static-1.19443",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8275",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5214",
  "one-click-checkout": "/one-click-checkout/static-1.298",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7821",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15162",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3735",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9935",
  "redux-thunk": "/redux-thunk/static-2.43",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "react-flip-move": "/react-flip-move/static-1.74",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29163",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13027",
  "fix-webm-duration": "/fix-webm-duration/static-1.26",
  "notification-sounds": "/notification-sounds/static-1.4643",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.531",
  "ui-addon-opt": "/ui-addon-opt/static-4.8579",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6496",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5298",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3754",
  "data-token-picker": "/data-token-picker/static-1.16778",
  "FileManagerLib": "/FileManagerLib/static-1.39936",
  "content-media-compositions": "/content-media-compositions/static-2.17034",
  "media-bridge-lib": "/media-bridge-lib/static-1.19297",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22470",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3346",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7087",
  "card-properties-lib": "/card-properties-lib/static-1.44849",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37624",
  "crm-actions": "/crm-actions/static-1.6568",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44310",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9807",
  "customer-data-tracking": "/customer-data-tracking/static-1.7101",
  "hs-resources": "/hs-resources/static-1.403",
  "calling-global-api": "/calling-global-api/static-1.65273",
  "calling-internal-common": "/calling-internal-common/static-1.31532",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66655",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58949",
  "commerce-products-lib": "/commerce-products-lib/static-1.10346",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3948",
  "crm-links": "/crm-links/static-1.6536",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4430",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4285",
  "formula-editor": "/formula-editor/static-1.14636",
  "google-libphonenumber": "/google-libphonenumber/static-1.41",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4365",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.852",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3842",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49459",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4118",
  "smart-property-lib": "/smart-property-lib/static-1.8125",
  "tiered-pricing": "/tiered-pricing/static-1.1815",
  "topics-actions-lib": "/topics-actions-lib/static-1.376",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11204",
  "zustand": "/zustand/static-1.79",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.230",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.341",
  "event-emitter": "/event-emitter/static-1.1170",
  "fast-json-patch": "/fast-json-patch/static-1.66",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1471",
  "growth-data-modal": "/growth-data-modal/static-1.5779",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3277",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2542",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1066",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7860",
  "academy-service-client": "/academy-service-client/static-1.3906",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39795",
  "SafeStorage": "/SafeStorage/static-1.4621",
  "video-embed": "/video-embed/static-1.36481",
  "redux-actions": "/redux-actions/static-3.7",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24868",
  "viral-links-lib": "/viral-links-lib/static-1.7291",
  "nested-table": "/nested-table/static-1.453",
  "timezone-utils": "/timezone-utils/static-2.5465",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18175",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9929",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5542",
  "customer-data-views-management": "/customer-data-views-management/static-1.25890",
  "framework-data-table": "/framework-data-table/static-2.12398",
  "nudge-client-utils": "/nudge-client-utils/static-1.3028",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1382",
  "switchboard-lib": "/switchboard-lib/static-1.439",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1424",
  "app-users-service-client": "/app-users-service-client/static-1.5834",
  "app-users-service-types": "/app-users-service-types/static-1.5242",
  "mini-checkout-client": "/mini-checkout-client/static-1.27393",
  "onboarding-utils": "/onboarding-utils/static-1.5580",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2104",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29148",
  "checkout-sdk": "/checkout-sdk/static-3.24236",
  "payment-method-components": "/payment-method-components/static-1.7065",
  "touchless-buying-components": "/touchless-buying-components/static-1.6104",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3706",
  "edison-service-client-types": "/edison-service-client-types/static-1.605",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6800",
  "audio-components": "/audio-components/static-1.6236",
  "FileManagerImages": "/FileManagerImages/static-1.37447",
  "video-components": "/video-components/static-1.13991",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92683",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46595",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.17667",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4479",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1641",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19872",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19082",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10912",
  "crm-fe-perf": "/crm-fe-perf/static-1.23116",
  "calling-error-reporting": "/calling-error-reporting/static-1.31539",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11257",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6757",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1798",
  "commerce-permissions": "/commerce-permissions/static-1.995",
  "products-iframe-lib": "/products-iframe-lib/static-1.8448",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10862",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6659",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10563",
  "sales-views-client-types": "/sales-views-client-types/static-1.4475",
  "bark-lib": "/bark-lib/static-1.16723",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.533",
  "policy-lib": "/policy-lib/static-1.7011",
  "react-tinymce": "/react-tinymce/static-1.55822",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10626",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54948",
  "tinymce-plugins": "/tinymce-plugins/static-1.58062",
  "tinymce-themes": "/tinymce-themes/static-1.56918",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2350",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2570",
  "user-context-client": "/user-context-client/static-1.4754",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.57",
  "urlinator": "/urlinator/static-1.4749",
  "outpost": "/outpost/static-1.4380",
  "draft-convert": "/draft-convert/static-2.76",
  "draft-extend": "/draft-extend/static-3.79",
  "draft-js": "/draft-js/static-5.81",
  "draft-plugins": "/draft-plugins/static-2.22045",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4063",
  "ts-utils-lib": "/ts-utils-lib/static-1.391",
  "crm-export-dialog": "/crm-export-dialog/static-1.6503",
  "crm-view-components": "/crm-view-components/static-1.936",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.66",
  "customer-data-associations": "/customer-data-associations/static-1.7550",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2785",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3104",
  "whisper-core-api": "/whisper-core-api/static-1.7170",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15405",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46695",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.825",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4209",
  "company-details-components": "/company-details-components/static-1.6418",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.772",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15303",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3673",
  "social-insights-client-types": "/social-insights-client-types/static-1.22638",
  "crm_universal": "/crm_universal/static-1.22385",
  "customer-data-email": "/customer-data-email/static-1.18413",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37818",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.40047",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13090",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55449",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22038",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18629",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72688",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5552",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10056",
  "utility-belt": "/utility-belt/static-1.2749",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23652",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7885",
  "customer-data-rte": "/customer-data-rte/static-1.33516",
  "cv-backend-services": "/cv-backend-services/static-1.1590",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6154",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5323",
  "qrcode-generator": "/qrcode-generator/static-1.72",
  "quotes-client-types": "/quotes-client-types/static-1.38778",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36575",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16216",
  "hub-http-contrib": "/hub-http-contrib/static-1.3257",
  "interframe": "/interframe/static-3.4973",
  "tinymce-data": "/tinymce-data/static-1.41033",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5430",
  "layout-dnd-components": "/layout-dnd-components/static-1.12852",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11827",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16106",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9200",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7825",
  "access-control-lib": "/access-control-lib/static-1.10656",
  "EmailComponents": "/EmailComponents/static-1.55400",
  "EmailData": "/EmailData/static-1.54078",
  "redux-less": "/redux-less/static-2.9698",
  "company-details-service-types": "/company-details-service-types/static-1.4157",
  "segments-query-core": "/segments-query-core/static-1.1639",
  "pricing-pages-api": "/pricing-pages-api/static-1.15168",
  "sequences-lib": "/sequences-lib/static-1.8410",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10572",
  "products-ui-components": "/products-ui-components/static-1.40864",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7426",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55465",
  "commerce-products-api": "/commerce-products-api/static-1.2604",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57523",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103366",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81409",
  "stripe-connect-js": "/stripe-connect-js/static-1.73",
  "draft-content-plugins": "/draft-content-plugins/static-1.28779",
  "ContentData": "/ContentData/static-1.69075",
  "layout-data-lib": "/layout-data-lib/static-1.10152",
  "ContentComponents": "/ContentComponents/static-2.71956",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10808",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2056",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46976",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1838",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19509",
  "automation-ui-types": "/automation-ui-types/static-1.20427",
  "messaging-types-lib": "/messaging-types-lib/static-1.46713",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4727",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8267",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.759",
  "price-books-api": "/price-books-api/static-1.1564",
  "price-books-components": "/price-books-components/static-1.1622",
  "property-description-translator": "/property-description-translator/static-1.4057",
  "ramp-editor": "/ramp-editor/static-1.749",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3742",
  "totals-ui-components": "/totals-ui-components/static-1.24158",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9532",
  "advanced-menus-core": "/advanced-menus-core/static-1.15477",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12362",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34659",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6343",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7552",
  "data-token-views": "/data-token-views/static-1.16759",
  "forms-utils-lib": "/forms-utils-lib/static-1.12978",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13467",
  "simple-menus-core": "/simple-menus-core/static-1.15476",
  "simple-menus-lib": "/simple-menus-lib/static-1.16993",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7140",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7724",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.119",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3632",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2643",
  "ContentEditorUI": "/ContentEditorUI/static-2.77735",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4139",
  "web-interactives-components": "/web-interactives-components/static-1.14135",
  "web-interactives-data": "/web-interactives-data/static-1.14136",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1287",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1457",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1196",
  "line-items-api": "/line-items-api/static-1.1004",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3967",
  "FireAlarmUi": "/FireAlarmUi/static-1.4660",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4318",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22363",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21826",
  "data-studio-ubb": "/data-studio-ubb/static-1.3361",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27522",
  "content-management-data-lib": "/content-management-data-lib/static-1.5828",
  "copilot-plugins": "/copilot-plugins/static-1.11664",
  "cta-picker": "/cta-picker/static-1.36946",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3728",
  "editor-components": "/editor-components/static-1.13541",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8699",
  "error-messaging-js": "/error-messaging-js/static-1.5413",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86428",
  "pictos": "/pictos/static-7.189",
  "react-transition-group": "/react-transition-group/static-2.68",
  "redux-request-state": "/redux-request-state/static-1.10867",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1964",
  "smart-content-core": "/smart-content-core/static-1.43028",
  "smart-content-lib": "/smart-content-lib/static-1.43681",
  "social-composer-lib": "/social-composer-lib/static-1.59991",
  "structured-content-lib": "/structured-content-lib/static-1.25772",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53799",
  "tinymce-copilot": "/tinymce-copilot/static-1.17016",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8176",
  "automation-ui-routing": "/automation-ui-routing/static-1.21784",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5825",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42660",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3414",
  "reporting-enablement": "/reporting-enablement/static-1.23654",
  "forms-ai-lib": "/forms-ai-lib/static-1.4651",
  "codemirror-dlb": "/codemirror-dlb/static-1.59294",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6655",
  "report-customization-components": "/report-customization-components/static-1.13746",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13617",
  "reporting-filters": "/reporting-filters/static-1.863",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2402"
}
};
